import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';
import {
  OrderByPipe,
  FilterByPipe,
  UserNamePipe,
  TenantDescriptionPipe,
  UserAvatarPipe,
  GuardTypePipe,
  SecondsToHMSPipe,
  DateOffsetPipe,
  SafePipe,
  CampaignDescriptionPipe,
} from './pipes';
import { HttpErrorInterceptor } from './services';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MultiSelectComponent } from './components';
@NgModule({
  declarations: [
    OrderByPipe,
    FilterByPipe,
    UserNamePipe,
    TenantDescriptionPipe,
    UserAvatarPipe,
    GuardTypePipe,
    SecondsToHMSPipe,
    DateOffsetPipe,
    SafePipe,
    CampaignDescriptionPipe,
    MultiSelectComponent,
  ],
  imports: [CommonModule, ReactiveFormsModule, NgSelectModule],
  exports: [
    OrderByPipe,
    FilterByPipe,
    UserNamePipe,
    TenantDescriptionPipe,
    UserAvatarPipe,
    GuardTypePipe,
    SecondsToHMSPipe,
    DateOffsetPipe,
    SafePipe,
    CampaignDescriptionPipe,
    MultiSelectComponent,
  ],
  providers: [
    OrderByPipe,
    FilterByPipe,
    UserNamePipe,
    TenantDescriptionPipe,
    UserAvatarPipe,
    GuardTypePipe,
    SecondsToHMSPipe,
    DateOffsetPipe,
    SafePipe,
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    CampaignDescriptionPipe,
  ],
})
export class SharedModule {}
